import { Routes, useLocation, Route, Outlet } from 'react-router-dom';

import EmployeeList from '../employeeList/AllEmpoyee';
import EmployeeDetails from '../employeeDetail/index';
// import EmployeeDetails from "../../Employees/employeeDetail"
import { EmployeeProvider } from '../context/directoryContext';

function EmployeeRouter() {
  let { pathname } = useLocation();
  console.log(pathname,"EMPLOYEEE HEREEEEEEEEEEEEE")

  return (
    <EmployeeProvider>
    <Routes>
       <Route path="/" element={<Outlet />}>
        <Route index element={<EmployeeList />} /> {/* Matches `/employees` */}
        <Route path=":id" element={<EmployeeDetails />} /> {/* Matches `/employees/:id` */}
      </Route>
    </Routes>
    </EmployeeProvider>
  );
}

export default EmployeeRouter;
